import { site } from "@/lib/site";

export function SiteFooter() {
    return (
        <footer
            className="flex flex-col gap-6 px-(--kt-gutter) pt-9 pb-11
                wide:flex-row wide:items-end wide:justify-between"
        >
            <div>
                <p className="mb-2.5 text-[12px] uppercase tracking-label text-kt-ink/50">
                    Contact
                </p>
                <a
                    href={site.mailto}
                    className="text-[26px] tracking-email text-white transition-colors hover:text-kt-ink/80"
                >
                    {site.email}
                </a>
            </div>
            <p className="text-[12px] text-kt-ink/42">{site.copyright}</p>
        </footer>
    );
}
